module.exports = __webpack_public_path__ + "travail.png?e6d5621fb5dc0f4a9757ec2bfaaf8df1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/travail.png
// module id = 194
// module chunks = 0